import * as React from "react";


export const Headings = ({ text = '', type = 'h1' }) => {
    const CustomTag = type as keyof JSX.IntrinsicElements;

    return (
        <CustomTag className={`text__heading`}>
            {text}
        </CustomTag>
    );
};
